import { useEffect, useState } from 'react';
import { Constants } from '@/constants/constants';
import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import { Util } from '@/utils/utils';

let ASK_TYPE_PARTNERSHIP = 'AAKTYPE003';
const FRNC_ID_PARTNERSHIP = 'STELLA';
interface FormData {
	consultCompanyName: string;
	consultUserName: string;
	consultUserNumber: string;
	consultUserMail: string;
	consultUserInquiry: string;
	consultInquiryAgree: boolean;
}

const useInquiryForm = () => {
	const [formData, setFormData] = useState<FormData>({
		consultCompanyName: '',
		consultUserName: '',
		consultUserNumber: '',
		consultUserMail: '',
		consultUserInquiry: '',
		consultInquiryAgree: false
	});

	const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

	// 입력값 변경을 처리하는 함수
	const handleInputChange = (e: any) => {
		const { id, value, type, checked } = e.target;
		setFormData(prev => ({
			...prev,
			[id]: type === 'checkbox' ? checked : value
		}));
	};

	const changeAskType = (askType: string) => {
		ASK_TYPE_PARTNERSHIP = askType;
	};

	// 폼 데이터 제출 처리
	const inquiryPsClickSubmit = async () => {
		const {
			consultCompanyName,
			consultUserName,
			consultUserNumber,
			consultUserMail,
			consultUserInquiry,
			consultInquiryAgree
		} = formData;

		if (!consultCompanyName) {
			alert('회사명을 입력해 주세요.');
			return;
		}
		if (!consultUserName) {
			alert('이름을 입력해 주세요.');
			return;
		}
		if (!consultUserNumber) {
			alert('연락처를 정확히 입력해 주세요.');
			return;
		}
		if (!consultUserMail || !Util.isEmail(consultUserMail)) {
			alert('이메일을 정확히 입력해 주세요.');
			return;
		}

		const jsonData = {
			applyAskerBizNm: consultCompanyName,
			applyAskerNm: consultUserName,
			applyAskerPhoneNo: consultUserNumber,
			applyAskerEmail: consultUserMail,
			applyAskCtnt: consultUserInquiry.replace(/\n/g, '<br>'),
			applyAskType: ASK_TYPE_PARTNERSHIP,
			agreeYn: consultInquiryAgree ? Constants.yes : Constants.no,
			frncId: FRNC_ID_PARTNERSHIP
		};

		try {
			const response = await Remote.Api.post(ApiConstant.mgmtApplyAsk.save, jsonData);
			if (response.code !== Constants.apiSuccess) {
				alert(response.message);
				return;
			}

			alert('신규가입 상담 신청이 성공적으로 전송되었습니다.');
			setFormData({
				consultCompanyName: '',
				consultUserName: '',
				consultUserNumber: '',
				consultUserMail: '',
				consultUserInquiry: '',
				consultInquiryAgree: false
			});
			window.scrollTo(0, 0);
		} catch (error) {
			console.error('Error submitting inquiry:', error);
		}
	};

	const isFormValidate = () => {
		const { consultCompanyName, consultUserName, consultUserNumber, consultUserMail, consultInquiryAgree } = formData;

		return !!(
			consultCompanyName.trim() &&
			consultUserName.trim() &&
			consultUserNumber.trim() &&
			consultUserMail.trim() &&
			Util.isEmail(consultUserMail) &&
			consultInquiryAgree
		);
	};

	// 체크박스 동작을 추적하고 폼 제출 활성화 여부를 설정
	useEffect(() => {
		const isActive = isFormValidate();

		setIsSubmitEnabled(isActive);
	}, [
		formData.consultInquiryAgree,
		formData.consultCompanyName,
		formData.consultUserName,
		formData.consultUserNumber,
		formData.consultUserMail
	]);

	return {
		formData,
		isSubmitEnabled,
		handleInputChange,
		inquiryPsClickSubmit,
		changeAskType
	};
};

export default useInquiryForm;
